import { Box, InputBaseComponentProps, MenuItem, Select, Typography } from '@mui/material';
import { StyledFormControl, StyledInputLabel, TipLabel } from 'components/core/Select/styles';

import { AppFormLabel } from 'components/core/AppFormLabel/AppFormLabel';
import React from 'react';

export type SelectOptions<T extends string | number = string | number> = {
  value: T;
  label: string;
  disabled?: boolean;
}[];

export interface AppSelectProps {
  title?: string;
  description?: string;
  label?: string;
  value: any;
  options: SelectOptions;

  onChange?: any;
  name?: string;
  onBlur?: (e: React.FocusEvent<any>) => void;
  disabled?: boolean;
  size?: 'small' | 'medium';

  formControlDataTestId?: string;
  labelId?: string;
  inputProps?: InputBaseComponentProps | undefined;
  selectId?: string;
  tipLabel?: string;
  onClickTip?: () => void;

  fullWidth?: boolean;
  placeholder?: string;
}

export const AppSelect = ({
  title,
  description,
  label,
  value,
  options,
  name,
  disabled,
  size = 'small',
  onChange,
  onBlur,
  formControlDataTestId,
  labelId,
  inputProps,
  selectId,
  tipLabel,
  onClickTip,
  placeholder,
  fullWidth = true
}: AppSelectProps) => {
  const finalLabelId = labelId ?? `select-label-id-${label}`;

  return (
    <>
      <Box marginBottom={title || description ? '8px' : '0px'}>
        {title ? <AppFormLabel title={title} /> : null}
        {description ? <Typography variant="body2">{description}</Typography> : null}
      </Box>
      <StyledFormControl fullWidth={fullWidth} variant="outlined" size={size} data-testid={formControlDataTestId}>
        {label ? (
          <StyledInputLabel id={finalLabelId} disabled={disabled}>
            {label}
          </StyledInputLabel>
        ) : null}
        <Select
          name={name}
          labelId={finalLabelId}
          id={selectId}
          value={value}
          onChange={onChange}
          style={{ backgroundColor: '#fff' }}
          onBlur={onBlur}
          disabled={disabled}
          inputProps={inputProps}
          fullWidth={fullWidth}
          displayEmpty={!!placeholder}
          renderValue={value => {
            const option = options.find(option => option.value === value);
            if (!option) {
              if (placeholder) {
                return <Typography color="gray">{placeholder}</Typography>
              }
              return '';
            }
            return option.label ?? '';
          }}
        >
          {options.map(option => (
            <MenuItem key={option.value} value={option.value} disabled={option.disabled}>
              {option.label}
            </MenuItem>
          ))}
        </Select>
      </StyledFormControl>
      {tipLabel && <TipLabel onClick={onClickTip}>{tipLabel}</TipLabel>}
    </>
  );
};
